import { useDispatch } from "react-redux";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Tooltip from "@mui/material/Tooltip";
import { useAuth0 } from "@auth0/auth0-react";
import useCloneFlow from "hooks/useCloneFlow";
import { useSlugFlow } from "hooks/useSlugFlow";

import { setFlowVersionToDelete, setDeleteFlowVersionDialogOpen } from "redux/actions/flowDesigner/flowsActionCreator";

export const VersionAction = ({ version, iconOrientation, isEditor }) => {
   const [anchorEl, setAnchorEl] = useState(null);
   const open = Boolean(anchorEl);
   const { user } = useAuth0();
   const { handleCloneFlow } = useCloneFlow();
   const { flow } = useSlugFlow();
   const dispatch = useDispatch();

   const handleOpenMenu = (event) => {
      setAnchorEl(event.currentTarget);
   };

   const handleCloseMenu = () => {
      setAnchorEl(null);
   };

   const handleClone = async () => {
      handleCloneFlow(
         true,
         {
            ...flow,
            steps: version.steps
         },
         null,
         version
      );

      handleCloseMenu();
   };

   const canDelete = isEditor && flow.current_version !== version.version;

   const canOpenActions = () => {
      return !!user && (canDelete || isEditor);
   };

   const handleDelete = async () => {
      dispatch(setFlowVersionToDelete({ ...version }));
      dispatch(setDeleteFlowVersionDialogOpen(true));
      handleCloseMenu();
   };

   return (
      <>
         {canOpenActions() && (
            <IconButton aria-label="more" id="long-button" aria-controls={open ? "version-menu" : undefined} aria-expanded={open ? "true" : undefined} aria-haspopup="true" onClick={handleOpenMenu}>
               <Tooltip title="More Actions" placement="top">
                  {iconOrientation === "horizontal" ? <MoreHorizIcon /> : <MoreVertIcon />}
               </Tooltip>
            </IconButton>
         )}

         <Menu
            MenuListProps={{
               "aria-labelledby": "version-button"
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
         >
            <MenuItem sx={{ display: isEditor ? "block" : "none" }} onClick={handleClone}>
               Clone
            </MenuItem>
            <MenuItem
               sx={{
                  display: canDelete ? "block" : "none"
               }}
               onClick={handleDelete}
            >
               Delete
            </MenuItem>
         </Menu>
      </>
   );
};
